export default {
  title: "Мероприятия",
  empty: "Пока нет опубликованных мероприятий.",
  homeEmpty: "Ничего не найдено",
  kicker: "Афиша",
  homeSubtitle:
    "Лекции, выставки, мастер-классы и другие события экосистемы Ленинка IP для авторов, исследователей и креативных команд",
  homeExploreTitle: "Открыть полную афишу",
  homeExploreHint: "Лекции, выставки, мастер-классы — найдите событие для себя",
  homeExploreCount: "{{count}} событий в каталоге",
  homeExploreAria: "Перейти ко всем мероприятиям",
  detail: "Мероприятие",
  register: "Записаться",
  registerDone: "Вы записаны",
  loginToRegister: "Войдите, чтобы записаться",
  status: "Статус",
  when: "Когда",
  where: "Где",
  description: "Описание",
  loadFailed: "Не удалось загрузить мероприятия.",
  portal: {
    title: "Портал мероприятий",
    pageTitle: "Кабинет мероприятий",
    pageSubtitle: "Управляйте вашими мероприятиями и процессами модерации в одном месте.",
    pageSubtitleParticipant: "Находите и регистрируйтесь на мероприятия.",
    navAria: "Разделы кабинета мероприятий",
    overview: "Обзор",
    all: "Все",
    mine: "Мои мероприятия",
    created: "Созданные",
    attendance: "Посещаемость",
    moderation: "Модерация",
    registrations: "Регистрации",
    create: "Создать",
    overviewTitle: "Обзор кабинета",
    overviewSubtitle: "Выберите раздел для дальнейшей работы с мероприятиями.",
    createdHint: "Мероприятия, которыми вы управляете как организатор",
    visitsHint: "Мероприятия, на которые вы подали заявку",
    totalCreated: "Всего: {{count}}",
    goToSection: "Перейти в раздел",
    createTitle: "Новое мероприятие",
    titleField: "Название",
    descriptionField: "Описание",
    submit: "Создать черновик",
    submitReview: "На модерацию",
    emptyMine: "У вас пока нет мероприятий.",
    emptyModeration: "Очередь модерации пуста.",
    emptyRegistrations: "Нет регистраций.",
    approve: "Одобрить",
    reject: "Отклонить",
    forbidden: "Недостаточно прав для модерации.",
    emptyAttendance: "Нет мероприятий для отметки посещаемости.",
    checkIn: "Отметить вход",
    checkOut: "Отметить выход",
    searchPlaceholder: "Поиск по названию",
    sortNewest: "Сначала новые",
    sortOldest: "Сначала старые",
    sortTitle: "По названию",
    filters: "Фильтры афиши",
    galleryTitle: "Галерея",
    galleryThumbAria: "Фото {{index}} из {{total}}",
    subtitles: {
      created: "Черновики и опубликованные мероприятия, которые вы ведёте.",
      create: "Черновик можно дополнить и отправить на модерацию.",
      moderation: "Мероприятия организаторов, ожидающие публикации.",
      registrations: "Мероприятия, на которые вы записались.",
      attendance: "Отметьте, кто пришёл на мероприятие.",
      all: "Афиша опубликованных мероприятий.",
    },
    statuses: {
      draft: "черновик",
      pending_review: "на модерации",
      approved: "опубликовано",
      rejected: "отклонено",
      cancelled: "отменено",
    },
    columns: {
      title: "Мероприятие",
      status: "Статус",
      when: "Когда",
      actions: "Действия",
      participant: "Участник",
      registered: "Запись",
    },
    openEvent: "Открыть мероприятие",
    rejectTitle: "Отклонить мероприятие",
    rejectMessage: "«{{title}}» вернётся организатору и не попадёт в афишу.",
  },
}